import { Model } from '@vuex-orm/core';
import Residence from '@/models/Residence';

export default class ResidenceType extends Model {
  static entity = 'residenceTypes';

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(''),
      slug: this.attr(null),
      count: this.attr(null),
      description: this.attr(null),

      // relationships
      residences: this.hasMany(Residence, 'residencetype_id'),
    };
  }

  static transformer(data) {
    const types = [];
    data.data.forEach(item => {
      const type = {};
      type.id = item.id;
      type.name = item.name;
      type.slug = item.slug;
      type.count = item.count;
      type.description = item.description;
      types.push(type);
    })
    return types;
  }

  static apiConfig = {
    dataTransformer: (data) => this.transformer(data),
  }

  static fetch(baseURL) {
    let url = '/wp-json/wp/v2/type';
    return this.api().get(url, {
      baseURL: baseURL,
    });
  }
}
